import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        form: '=',
        room: '='
    },
    template: `
        <div class="well color01">
            <form class="form" ng-submit="vm.save()">
                <form-wrapper form="vm.form">
                    <form-row error="vm.form.errors.name">
                        <label class="label">{{ 'planning.Name' | translate }} *</label>
                        <div class="items">
                            <input ng-model="vm.form.model.name" type="text" class="form-control">
                            <form-row-error></form-row-error>
                        </div>
                    </form-row>
                    <form-row error="vm.form.errors.capacity">
                        <label class="label">{{ 'planning.Capacity' | translate }} *</label>
                        <div class="items">
                            <input ng-model="vm.form.model.capacity" type="number" class="form-control">
                            <form-row-error></form-row-error>
                        </div>
                    </form-row>
                    <form-row errors="vm.form.errors.location">
                        <label class="label">{{ 'planning.Location' | translate }}</label>
                        <div class="items">
                            <google-places place="vm.googlePlacesObject" default-value="vm.form.model.location"/>
                        </div>
                    </form-row>
                    <form-row error="vm.form.errors.locationDetails">
                        <label class="label">
                            {{ 'room.Location details' | translate }}
                            <small>{{ 'room.Details like "second floor, use stairs"' | translate }}</small>
                        </label>
                        <div class="items">
                            <input ng-model="vm.form.model.locationDetails" type="text" class="form-control">
                            <form-row-error></form-row-error>
                        </div>
                    </form-row>
                </form-wrapper>
                <button type="submit" class="hidden" >{{ 'general.Save changes' | translate }}</button>
            </form>
        </div>
        <ul class="actions01">
            <li class="primary">
                <a ng-click="vm.save()" class="btn main">
                    <span ng-if="vm.form.model.id">{{ 'general.Save' | translate }}</span>
                    <span ng-if="!vm.form.model.id">{{ 'planning.Add room' | translate }}</span>
                </a>
            </li>
            <li>
                <a ui-sref="authorized.courses.rooms.list()" class="btn discrete" >
                    <span ng-if="vm.form.model.id">{{ 'general.Back to list' | translate }}</span>
                    <span ng-if="!vm.form.model.id">{{ 'general.Cancel' | translate }}</span>
                </a>
            </li>
        </ul>
    `
})
export default class {
    constructor ($state, $translate, toastr) {
        this.$state = $state;
        this.$translate = $translate;
        this.toastr = toastr;
    }

    $onInit () {
        this.oldLocation = this.form.model.location;
    }

    save () {
        if (this.googlePlacesObject) {
            this.form.model.location = this.googlePlacesObject.formatted_address;
        }
        else if (this.form.model.location !== this.oldLocation) {
            this.form.model.location = null;
        }

        this.form.save()
            .then((model) => {
                this.form.saved = false; // this is for avoiding duplicated success message through form wrapper, COUR-4308
                this.toastr.success(this.$translate.instant('general.Changes saved'));
                this.room = model;
                this.$state.go('authorized.courses.rooms.detail', { id: model.id });
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/courses/rooms/form/index.js